<template>
  <!-- Total: 1+4+5+5+6+3+3+8+1 = 36 spans -->
  <div class="cardLayoutWrapper cardLayoutWrapper--header">
    <BasicCell :span="1" />
    <BasicCell
      :span="4"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="id"
      />
      <span>Référence</span>
    </BasicCell>
    <BasicCell
      :span="5"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="dateEmission"
      />
      <span>Date d'émission</span>
    </BasicCell>
    <BasicCell
      :span="5"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="dateReception"
      />
      <span>Date de réception</span>
    </BasicCell>
    <BasicCell :span="6">
      <span>Emetteur</span>
    </BasicCell>
    <BasicCell :span="3">
      <span>Montant HT</span>
    </BasicCell>
    <BasicCell :span="3">
      <span>Montant TTC</span>
    </BasicCell>
    <BasicCell
      :span="8"
      extra-class="elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="statut"
      />
      <span>Statut</span>
    </BasicCell>
    <BasicCell :span="1" />
  </div>
</template>

<script setup lang="ts">
  import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue'

  const modelValue = defineModel<string>()
</script>
